export const SITE_SHARE_TITLE = '86上山 Pub'
export const SITE_SHARE_DESCRIPTION = '今晚，上山见。点餐、预约与会员权益，尽在86上山。'
export const INVITE_SHARE_TITLE = '好友邀你上山｜86上山 Pub'
export const INVITE_SHARE_DESCRIPTION = '接受好友邀请，首次进店消费享基础奖励与邀请加赠，查看活动详情。'
export const SITE_SHARE_IMAGE_PATH = '/share/store-logo-86-v2.jpg'
export const SITE_SHARE_IMAGE_URL = `https://86shangshan.pub${SITE_SHARE_IMAGE_PATH}`
export const INVITE_SHARE_IMAGE_PATH = '/share/invite-store-logo-86-v3.jpg'
export const INVITE_SHARE_IMAGE_URL = `https://86shangshan.pub${INVITE_SHARE_IMAGE_PATH}`

export function invitationShareHeadline(inviterNickname?: string) {
  return `${inviterNickname?.trim() || '好友'}邀你上山`
}

export function invitationShareTitle(inviterNickname?: string) {
  return `${invitationShareHeadline(inviterNickname)}｜86上山 Pub`
}

// Keep SPA navigation in sync with the metadata in index.html / invite.html.
// Never replace an invitation's URL with the homepage: the code must survive sharing.
export function updateShareMetadata(pathname: string, inviterNickname?: string) {
  const invitation = /^\/invite\/[^/]+\/?$/.test(pathname) || pathname === '/referral'
  const title = invitation ? invitationShareTitle(inviterNickname) : SITE_SHARE_TITLE
  const description = invitation ? INVITE_SHARE_DESCRIPTION : SITE_SHARE_DESCRIPTION
  const image = invitation ? INVITE_SHARE_IMAGE_URL : SITE_SHARE_IMAGE_URL
  const imageType = 'image/jpeg'
  const imageAlt = '86上山 Pub 门店 Logo'
  document.title = title
  for (const [attribute, name, content] of [
    ['name', 'description', description],
    ['property', 'og:title', title],
    ['property', 'og:description', description],
    ['property', 'og:image', image],
    ['property', 'og:image:type', imageType],
    ['property', 'og:image:alt', imageAlt],
    ['name', 'twitter:title', title],
    ['name', 'twitter:description', description],
    ['name', 'twitter:image', image]
  ]) {
    document.querySelector(`meta[${attribute}="${name}"]`)?.setAttribute('content', content)
  }
}
